
import BaseButton from '@/components/BaseButton.vue';
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'SendSummaryBox',
  components: { BaseButton },
  props: {
    approved: {
      type: Number,
      default: 0,
    },
    edited: {
      type: Number,
      default: 0,
    },
    rejected: {
      type: Number,
      default: 0,
    }
  },
  emits: ['onSendSummary'],
  setup(props) {
    console.log('setup');
    const message = computed(() => {
      let str = '';
      const haveRejections = props.rejected > 0;
      const haveApproved = props.approved > 0;
      const haveEdited = props.edited > 0;
      if(haveRejections) {
        str += `You rejected ${props.rejected} questions. Would you like to send an email to partner requesting to fix these answers?`;
        return str;
      }

      if(props.approved > 0) {
        const isOne = props.approved === 1;
        str += `You approved ${props.approved} question${isOne ? "" : 's'}${haveEdited ? '' : '.'}`
      }
      if(props.edited > 0) {
        const isOne = props.edited === 1;
        str += `${haveApproved ? ' and': 'You'} edited ${props.edited} question${isOne ? "" : 's'}.`
      }

      str += ` Would you like a summary sent to the partner?`
      return str;
    })
    return {
      message
    }
  }

});
